import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';

export type EnableUserConfirmData = {
  email: string;
};

@Component({
  selector: 'app-enable-user-confirm-dialog',
  standalone: true,
  imports: [MaterialModule, MatDialogModule],
  templateUrl: './enable-user-confirm-dialog.component.html',
})
export class EnableUserConfirmDialogComponent {
  #dialogRef = inject(MatDialogRef<EnableUserConfirmDialogComponent, boolean>);
  data: EnableUserConfirmData = inject(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.#dialogRef.close(true);
  }
}
